import { useTranslation } from "react-i18next";
import PageWrapper from "../../../../components/common/layout/PageWrapper";
import Users from "../../../../components/admin/users/Users";

const UsersManagement = () => {
  const { t } = useTranslation();

  return (
    <PageWrapper title={t("t.page.users.admin")}>
      <Users />
    </PageWrapper>
  );
};

export default UsersManagement;
